import { BaseDataService } from './BaseDataService';
import { UserStyle } from '../../models';
import { NotificationService } from '../../services';

export class UserStyleDataService extends BaseDataService<UserStyle> {
    constructor(notificationService: NotificationService) {
        super('UserStyle', 'UserStyles', notificationService);
    }

    public getBySurveyInstance(id: string): Promise<UserStyle> {
        const endpoint = `${this.endpointRoot}/bysurveyinstance/${id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                if (response.status === 204) {
                    return null;
                }
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public updateBySurveyInstance(id: string, styleId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurveyinstance/${id}/${styleId}`;
        const init = this.buildRequestInit('PUT');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                if (styleId !== -1) {
                    return response.json();
                } else {
                    return null;
                }
            }
            throw new Error('Network response was not ok.');
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/UserStyleData.tsx